import $ from 'jquery';

export default {
  sendLogBehavior({
    resourceType, resourceId, behaviorAction, extraValues = {},
  } = {}) {
    $.ajax({
      type: 'POST',
      url: this.logUrl || '/log_behavior',
      dataType: 'json',
      data: {
        resource_type: resourceType || this.tagName,
        resource_id: resourceId,
        behavior_action: behaviorAction,
        extra_values: { name: this.name, ...extraValues },
      },
    })
      .catch(e => console.error(e));
  },
};
